:host {
  display: flex;

  sy-row {
    margin-left: auto;
  }

  sy-router-link,
  .cookies {
    margin-right: 16px;
    margin-bottom: 16px;
    color: var(--sy-foreground-medium-emphasis, #5d6268ff);
    text-decoration: none;
  }

  sy-router-link:hover,
  .cookies:hover {
    color: #ffff;
    cursor: pointer;
  }
}
